import { Controller } from '@hotwired/stimulus';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/js/utils.js';

import 'intl-tel-input/build/css/intlTelInput.css';

export default class extends Controller {
  constructor(...args) {
    super(...args);

    this.input = null;
    this.hidden_input = null;
    this.error_container = null;
    this.iti = null;
  }

  connect() {
    this.input = this.element.querySelector('input');

    let preferredCountries = ['pl'];

    if (this.input.dataset.hasOwnProperty('preferredCountries')) {
      try {
        preferredCountries = JSON.parse(this.input.dataset.preferredCountries);
      } catch (e) {
        console.log('Could not parse preferredCountries.');
      }
    }

    let intlOptions = {
      preferredCountries: preferredCountries,
      formatAsYouType: false,
    };

    this.iti = intlTelInput(this.input, intlOptions);

    this.element.querySelector('.iti').style.display = 'block';

    this.createHiddenInput();

    this.element.addEventListener(
      'open:countrydropdown',
      () => (this.element.style.overflow = 'visible'),
    );

    this.element.addEventListener('close:countrydropdown', () => {
      this.element.style.overflow = 'hidden';
      this.handleChange();
    });

    this.input.addEventListener('countrychange', () => this.handleChange());
    this.input.addEventListener('keyup', () => this.handleChange());
  }

  createHiddenInput() {
    const input_name = this.input.name;
    this.input.removeAttribute('name');

    this.hidden_input = document.createElement('input');
    this.hidden_input.type = 'hidden';
    this.hidden_input.setAttribute('name', input_name);
    this.hidden_input.setAttribute('value', this.iti.getNumber());
    if (this.input.disabled) {
      this.hidden_input.setAttribute('disabled', 'disabled');
    }

    this.input.parentNode.appendChild(this.hidden_input);
  }

  createErrorContainer() {
    if (this.error_container !== null) {
      return;
    }

    this.error_container = document.createElement('div');
    this.error_container.className = 'error';
    this.element.appendChild(this.error_container);
  }

  destroyErrorContainer() {
    if (this.error_container !== null) {
      this.error_container.parentNode.removeChild(this.error_container);
      this.error_container = null;
    }
  }

  handleChange() {
    if (this.validatePhoneNumber()) {
      this.hidden_input.value = this.iti.getNumber();
      this.destroyErrorContainer();
    } else {
      this.hidden_input.value = this.formatInvalidNumber();
      this.createErrorContainer();
      this.error_container.innerHTML = this.element.dataset.errorsInvalid;
    }
  }

  formatInvalidNumber() {
    const dialCode = this.iti.selectedCountryData.dialCode;
    const number = this.iti.getNumber();

    if (number.startsWith('+')) {
      return number;
    } else {
      return `+${dialCode}${number}`;
    }
  }

  validatePhoneNumber() {
    if (this.input.value.length == 0) {
      return true;
    }

    const validFormat = this.iti.isValidNumber();

    const numberTypes = window.intlTelInputUtils.numberType;
    const validType = [
      numberTypes.MOBILE,
      numberTypes.FIXED_LINE_OR_MOBILE,
    ].includes(this.iti.getNumberType());

    const result = validFormat && validType;

    this.dispatchValidationEvent(result);
    return result;
  }

  dispatchValidationEvent(result) {
    const validationEvent = new CustomEvent('intl-phone-validation', {
      detail: { success: result },
    });

    Promise.resolve().then(() => {
      window.dispatchEvent(validationEvent);
    });
  }

  disconnect() {
    this.iti.destroy();
  }
}
